export enum HttpStatusCode {
    Conflict = 409,
    BadRequest = 400,
    NoContent = 204,
    OK = 200,
    Created = 201,
    Accepted = 202,
    Unauthorized = 401
}
